import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { ThirdPartyLoginErrorMessage } from 'app/core/http';
import { SetPage } from 'app/core/page';
import { SetException } from 'app/core/status';
import { SurveyConfig } from 'app/core/survey-config';
import { triggerThirdPartyLoginFailedMessage } from './triggerThirdPartyLoginFailedMessage';
import { SetIsCompleted } from './types';

export type CheckThirdPartyLoginDeps = [
  SurveyConfig,
  SurveyCakeLogicEngine,
  SetPage,
  SetException,
  SetIsCompleted
];

export async function checkThirdPartyLogin(
  checker: () => Promise<string>,
  deps: CheckThirdPartyLoginDeps
) {
  const [surveyConfig, engine, setPage, setException, setIsCompleted] = deps;

  try {
    const id = await checker();
    engine.setThirdPartyLogin(id);
    surveyConfig.handleStageFinished(setPage, setException);
  } catch (error) {
    const errorMessage = error.message as ThirdPartyLoginErrorMessage;

    if (errorMessage === 'ALREADY_DONE') {
      setIsCompleted(true);
    } else if (
      errorMessage === 'LOGIN_FAILED' ||
      errorMessage === 'TOKEN_ERROR'
    ) {
      const { wording } = surveyConfig;
      triggerThirdPartyLoginFailedMessage(wording);
    }
  }
}
